import React, { Component } from "react";
import * as FlexLayout from "flexlayout-react";
import UserAccounts from "./userAccounts";
import UserAccount from "./userAccount";
import { withTranslation } from "react-i18next";

class UserAccountAdmin extends Component {
  LAYOUT = {
    global: {
      minWidth: 100,
      minHeight: 100,
    },
    borders: [],
    layout: {
      type: "row",
      children: [
        {
          type: "tabset",
          weight: 50,
          enableMaximize: false,
          children: [
            {
              type: "tab",
              name: this.props.t("UserAccounts"),
              enableClose: false,
              component: "UserAccounts",
            },
          ],
        },
        {
          //Figure out how to make this persistent even when empty.
          type: "tabset",
          id: "1",
          weight: 50,
          enableDeleteWhenEmpty: false,
          enableMaximize: false,
          children: [
            // {
            //   type: "tab",
            //   name: "User",
            //   visible: false,
            //   component: "Placeholder"
            // }
          ],
        },
      ],
    },
  };

  state = {
    model: FlexLayout.Model.fromJson(this.LAYOUT),
  };

  handleUserAccountSelect = (userAccount, submitCallbackFunction, isNew) => {
    const { userAccountId, login } = userAccount;

    try {
      this.state.model.doAction(
        FlexLayout.Actions.addNode(
          {
            type: "tab",
            component: "UserAccount",
            name: `${login}`,
            id: `${userAccountId}`,
            config: { userAccountId, submitCallbackFunction, isNew },
          },
          "1",
          FlexLayout.DockLocation.CENTER,
          0,
          true
        )
      );
    } catch {
      this.state.model.doAction(FlexLayout.Actions.selectTab(userAccountId));
    }
  };

  handleTabRename = (nodeId, name) => {
    this.state.model.doAction(
      FlexLayout.Actions.updateNodeAttributes(nodeId, { name: name })
    );
  };

  factory = (node) => {
    const componentId = node.getComponent();

    if (componentId === "UserAccounts") {
      return (
        <UserAccounts
          onClick={this.handleUserAccountSelect}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "UserAccount") {
      const { userAccountId, submitCallbackFunction, isNew } = node.getConfig();
      return (
        <UserAccount
          userAccountId={userAccountId}
          submitCallbackFunction={submitCallbackFunction}
          isNew={isNew}
          onRename={this.handleTabRename}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "Placeholder") {
      return <div></div>;
    } else {
      return null;
    }
  };

  buildFlexLayout = () => {
    return (
      <div className="flex-container">
        <FlexLayout.Layout model={this.state.model} factory={this.factory} />;
      </div>
    );
  };

  render() {
    const { model } = this.state;

    return (
      <div className="flex-container auth-container">
        <FlexLayout.Layout
          model={model}
          factory={this.factory}
          onRenderTabSet={this.onRenderTabSet}
        />
      </div>
    );
  }
}

export default withTranslation(["auth"])(UserAccountAdmin);
